import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';

interface LeavePageDialogProps {
  open: boolean;
  onLeave: () => void;
  onStay: () => void;
}

const LeavePageDialog: React.FC<LeavePageDialogProps> = ({ open, onLeave, onStay }) => (
  <Dialog open={open} onClose={onStay} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ fontWeight: 700 }}>Leave this page?</DialogTitle>
    <DialogContent>
      <Typography>
        Are you sure you want to leave this page? Any changes that were made will not be saved.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ padding: '16px 24px', gap: '8px' }}>
      <Button
        onClick={onStay}
        variant="outlined"
        color="inherit"
        sx={{ textTransform: 'none', borderRadius: '50px' }}
      >
        Cancel
      </Button>
      <Button
        onClick={onLeave}
        variant="contained"
        color="error"
        sx={{ textTransform: 'none', borderRadius: '50px' }}
      >
        Leave
      </Button>
    </DialogActions>
  </Dialog>
);

export default LeavePageDialog;
